import { render, staticRenderFns } from "./TableContentDisplayer.vue?vue&type=template&id=0da06383&scoped=true&"
import script from "./TableContentDisplayer.vue?vue&type=script&lang=js&"
export * from "./TableContentDisplayer.vue?vue&type=script&lang=js&"
import style0 from "./TableContentDisplayer.vue?vue&type=style&index=0&id=0da06383&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da06383",
  null
  
)

export default component.exports